/* @flow */

import { getUserId } from '@braindate/domain/lib/user/util';
import { TAG_TYPE } from 'src/shared/app/base/api/apiConstant';
import {
  userEndpoint,
  usersEndpoint,
} from 'src/shared/app/base/settings/endpointSettings';
import { apiRoot } from 'src/shared/app/base/api/apiRoot';
import {
  getQueryTag,
  infiniteLoadingSettings,
} from 'src/shared/app/base/api/utils/endpointUtils';
import { defaultLimitPages } from 'src/shared/app/base/api/constant/apiConstant';
import type { User } from '@braindate/domain/lib/user/type';

const extendedApi = apiRoot.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query({
      query: ({ id, eventId }) => ({
        url: userEndpoint(id, eventId),
        params: {
          annotate_keywords_state: true,
        },
      }),
      providesTags: (result, _) =>
        getQueryTag(TAG_TYPE.USER, getUserId(result)),
    }),
    getUsersForMarket: builder.query({
      query: ({ params, page = 1 }) => ({
        url: usersEndpoint(),
        params: {
          ...params,
          limit: defaultLimitPages,
          offset: (page - 1) * defaultLimitPages,
          random_order: true,
          people_tab_optin: true,
          visible: true,
          for_marketplace: 1,
          extended_search: true,
          show_statistics: true,
          annotate_keywords_state: true,
        },
      }),
      ...infiniteLoadingSettings<User>({
        tagType: TAG_TYPE.TOPIC,
        idGetter: getUserId,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserQuery, useGetUsersForMarketQuery } = extendedApi;
